import React, { useCallback, useState } from 'react';

import { useSpdCore } from '../../../common/hooks/useSpdCore';

import { JudgmentsSearch } from './JudgmentsSearch';

export const JudgmentsList: React.FC = () => {
  const spd = useSpdCore();
  const [refresh, setRefresh] = useState<boolean>(false);

  const handleClick = useCallback(
    async (id: string) => {
      await spd.judgments.get(id);
    },
    [spd.judgments],
  );

  const onRefresh = () => {
    setRefresh(prev => !prev);
  };

  const getData = useCallback(
    (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) =>
      spd.judgments.getAllByPortion(
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
        onRefresh,
      ),
    [spd.judgments],
  );

  return (
    <>
      <JudgmentsSearch
        getData={getData}
        getCount={spd.judgments.getAllCount}
        onRowClick={handleClick}
        refresh={refresh}
        withHistory={true}
        withFilterInColumns={true}
      />
    </>
  );
};
